import { render, staticRenderFns } from "./v-navbar-notifications.vue?vue&type=template&id=56ca9eb1&scoped=true&"
import script from "./v-navbar-notifications.vue?vue&type=script&lang=js&"
export * from "./v-navbar-notifications.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-notifications.vue?vue&type=style&index=0&id=56ca9eb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca9eb1",
  null
  
)

export default component.exports